export default __webpack_public_path__ + "static/media/about_fabric3.6d3dd760.png";